import { render } from "./serviceCard.vue?vue&type=template&id=ff8e8b1e&scoped=true"
import script from "./serviceCard.vue?vue&type=script&lang=js"
export * from "./serviceCard.vue?vue&type=script&lang=js"

import "./serviceCard.vue?vue&type=style&index=0&id=ff8e8b1e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff8e8b1e"]])

export default __exports__